/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

const input = require('b_').with('input');

export const TextInput = ({
    id,
    required,
    disabled,
    error,
    type,
    name,
    placeholder,
    value,
    readOnly,
    onChange,
    onBlur,
    onClick,
    pattern,
    autoComplete = 'off',
    autoFocus,
}) => (
    <input
        id={id}
        required={required}
        disabled={disabled}
        className={input({ error: !!error })}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        title=""
        onChange={onChange}
        pattern={pattern}
        onClick={onClick}
        autoComplete={autoComplete}
        onBlur={onBlur}
        readOnly={readOnly}
        spellCheck="false"
        autoFocus={autoFocus}
    />
);
